import Button from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import React from "react";
import useBreakpointRanges from "utilities/hooks/use-breakpoint-ranges";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import { useBookviewTabPanel } from "utilities/contexts/bookview-tab-panel/use-bookview-tab-panel";
import { useLocalization } from "utilities/hooks/use-localization";
import { useMobileSecondaryNavContent } from "utilities/contexts/use-mobile-secondary-nav/use-mobile-secondary-nav-content";

const BASE_CLASS_NAME = "c-bookview-user-preferences-button";

const BookviewUserPreferencesButton = () => {
    const { toggleBookViewUserPreferences, isBookviewUserPreferencesOpen } =
        useBookviewTabPanel();
    const { toggleUserPreferencesModal } = useMobileSecondaryNavContent();

    const { t } = useLocalization();
    const { inMobileView: showMobileNav } = useBreakpointRanges();

    return (
        <div className={`${BASE_CLASS_NAME}`}>
            {showMobileNav ? (
                <Button
                    onClick={toggleUserPreferencesModal}
                    ariaLabel={t("open-bookview-user-preferences")}>
                    <Icon
                        size={IconSizes.Large}
                        type={Icons.Preferences}
                        cssClassName={`${BASE_CLASS_NAME}__icon`}
                    />
                    <span className={`${BASE_CLASS_NAME}__text`}>
                        {t("preferences")}
                    </span>
                </Button>
            ) : (
                <Button
                    cssClassName={`${BASE_CLASS_NAME}__button ${isBookviewUserPreferencesOpen ? "-panel-open" : ""}`}
                    ariaLabel={t("open-bookview-user-preferences")}
                    onClick={toggleBookViewUserPreferences}
                    size={ButtonSizes.XSmall}
                    style={ButtonStyles.TertiaryAlt}>
                    <Icon
                        type={Icons.Preferences}
                        size={IconSizes.Large}
                        cssClassName={`${BASE_CLASS_NAME}__icon`}
                    />
                </Button>
            )}
        </div>
    );
};

export default BookviewUserPreferencesButton;
